import { useSession } from '../contexts';
import { useUserRegisteredTournamentsAPIQuery } from '../services/queries';

export const useUserRegisteredTournaments = () => {
  const { isAuthenticated } = useSession();
  return useUserRegisteredTournamentsAPIQuery({
    enabled: isAuthenticated,
  });
};
